// a listagem nao salva pelo crud padrao: o cadastro e validado no back e salvo pelo AgendarRelatorioDialog
export function validate(record) {
  return Promise.resolve({ ok: true, errors: [], record })
}
